import { useDemandeAFStore } from './useDemandeAFStore'
import type { DemandeAFActions } from './DemandeAF.type'
import { buildDemandeActions } from '../shared'

export function useDemandeAFActions(): DemandeAFActions {
  const store = useDemandeAFStore()

  const actionsDemande = buildDemandeActions({
    dispositif: 'AF',
    store: store as any,
  })

  return {
    ...actionsDemande,
  }
}
